<ion-item [fill]="isCompact ? null : 'outline'">
  <ion-label *ngIf="!isCompact" position="stacked">{{ 'search.exercise' | translate }}</ion-label>
  <ion-input type="text" [ngModel]="searchValue" (ngModelChange)="searchValueChange($event)" cdkOverlayOrigin #trigger="cdkOverlayOrigin" [placeholder]="'search.exercise' | translate" class="exercise-search"></ion-input>
  <ion-button size="default" shape="round" fill="outline" color="secondary" slot="end" (click)="openExerciseFilterModal()" [attr.title]="'exercise.filter.modal.title' | translate" *ngIf="showExerciseFilterButton">

    <span class="ion-hide-lg-down">{{'exercise.open.search' | translate}}</span>

    <ion-icon class="ion-hide-lg-down" slot="end" name="open-outline"></ion-icon>
    <ion-icon class="ion-hide-lg-up" name="open-outline"></ion-icon>
  </ion-button>
</ion-item>

<ng-template
  [cdkConnectedOverlayWidth]="280"
  [cdkConnectedOverlayHeight]="300"
  [cdkConnectedOverlayPush]="true"
  (backdropClick)="hideAutoCompleteItems()"
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="!(hideAutoCompleteItems$ | async)"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayViewportMargin]="16"
  [cdkConnectedOverlayPositions]="[
      {
        originY: 'bottom',
        overlayY: 'top',
        originX: 'start',
        overlayX: 'start',
        offsetX: -16
      },
      {
        originY: 'top',
        overlayY: 'bottom',
        originX: 'start',
        overlayX: 'start',
        offsetX: -16
      },
    ]"
>
  <div class="autocomplete-items" tabindex="-1">
    <ion-item *ngFor="let hit of exerciseSearchHits$ | async; let index = index" (click)="selectItem(hit)" button [tabindex]="1000 + index" (keydown)="ionItemKeyDown($event, index, hit)" (keydown.ArrowDown)="ionItemArrowDown($event, index)" (keydown.ArrowUp)="ionItemArrowUp($event, index)">
      <img *ngIf="hit.videos[0]?.photoUrl as photoUrl" [src]="photoUrl" loading="lazy" class="ion-margin-end">
      {{ hit.name }}
      <span *ngIf="hit['level']">({{ hit['level'] }})</span>
    </ion-item>
  </div>
</ng-template>

